import React from 'react';
import styles from './Features.css';
import { DeluxeContext } from '../';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { featuresList } from './FeaturesList';
import { Title } from '../../title';

export const FeatureCard = ({ icon, title, ...restProps }) => {
  return (
    <section {...restProps}>
      <FontAwesomeIcon icon={icon} className={styles.icon} />
      <Title Tag='h2'>
        {title}
      </Title>
    </section>
  );
};

export const Features = () => {
  return (
    <DeluxeContext.Consumer>
      {({ onClickHandlers }) => {
        const { featureCardHandler } = onClickHandlers;
        return (
          <>
            <Title Tag='h1'>
              DIT KRIJG JE ERBIJ
            </Title>
            <p>
              Klik op de features voor meer informatie.
            </p>
            <div className={styles['features-container']}>
              {featuresList.map(feature => {
                const { title, icon } = feature;
                return (
                  <FeatureCard
                    title={title}
                    icon={icon}
                    key={title}
                    onClick={() => featureCardHandler(title)}
                  />
                );
              })}
            </div>      
          </>
        );
      }}
    </DeluxeContext.Consumer>
  );
};
